import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { FormControl, FormsModule } from '@angular/forms'
import { BasicInputComponent } from '@app/v2/shared/components/inputs/basic-input/basic-input.component'
import { DateRangePickerComponent } from '../../../components/date-range-picker/date-range-picker.component'
import { DisabledYearMonthDayRange } from '../../../components/date-range-picker/date-range-picker-content/date-range-picker-content.component'
import { EventTimePickerComponent } from '../../../components/event-time-picker/event-time-picker.component'
import { TimingExceptionHoursMode } from '../../../../../enums/event.enum'
import { DayWeekShort } from '../../../../../types/event.type'

@Component({
  selector: 'app-timing-exception-form',
  standalone: true,
  templateUrl: './timing-exception-form.component.html',
  styleUrl: './timing-exception-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, BasicInputComponent, DateRangePickerComponent, EventTimePickerComponent]
})
export class TimingExceptionFormComponent {
  public readonly TimingExceptionHoursMode = TimingExceptionHoursMode
  public readonly titleControl = input.required<FormControl<string>>()
  public readonly titleInputId = input.required<string>()
  public readonly titlePlaceholder = input.required<string>()

  public readonly hoursRadioName = input.required<string>()

  public readonly dateInputId = input.required<string>()
  public readonly dateDisplayControl = input.required<FormControl<string>>()

  public readonly startDate = input.required<string | null>()
  public readonly endDate = input.required<string | null>()
  public readonly hoursMode = input.required<TimingExceptionHoursMode>()

  public readonly startHour = input.required<string>()
  public readonly startMinute = input.required<string>()
  public readonly endHour = input.required<string>()
  public readonly endMinute = input.required<string>()

  public readonly timeRangeError = input.required<string | null>()

  public readonly eventPublicStartDate = input.required<string | null>()
  public readonly eventPublicEndDate = input.required<string | null>()
  public readonly disabledDateRanges = input.required<DisabledYearMonthDayRange[]>()
  public readonly silentDisabledDateRanges = input.required<DisabledYearMonthDayRange[]>()
  public readonly allowedWeekDays = input.required<DayWeekShort[] | null>()

  public readonly rangeSelected = output<{ startDate: string; endDate: string | null }>()
  public readonly hoursModeChange = output<TimingExceptionHoursMode>()
  public readonly startHourChange = output<string>()
  public readonly startMinuteChange = output<string>()
  public readonly endHourChange = output<string>()
  public readonly endMinuteChange = output<string>()
}
